<div class="title">{{ question.getLabel() + ".title" | translate }}</div>
<p class="info">{{ question.getLabel() + ".info_1" | translate }}</p>
<p class="info">{{ question.getLabel() + ".info_2" | translate }}</p>
<p class="info" [innerHTML]="question.getLabel() + '.info_3_md' | markdownTranslate"></p>
<p class="info" [innerHTML]="question.getLabel() + '.info_4_md' | markdownTranslate"></p>
<ul class="list">
	<li>{{ question.getLabel() + ".list_item_1" | translate }}</li>
	<li>{{ question.getLabel() + ".list_item_2" | translate }}</li>
	<li>{{ question.getLabel() + ".list_item_3" | translate }}</li>
	<li>{{ question.getLabel() + ".list_item_4" | translate }}</li>
	<li>{{ question.getLabel() + ".list_item_5" | translate }}</li>
</ul>

